import React from 'react';


const ResponsiveTable = ({ records, handleRowClick }) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const renderTableRows = () => {
    return records.map((item, index) => (
      <tr key={index} className="table-row" style={{ cursor: 'pointer' }}>
        <td>{index + 1}</td>
        <td onClick={() => handleRowClick(item)}>
          {`${item.name} ولد ${item.fatherName}`}<br />
          <b>{item.phone}</b><br />
          {`بمقام : مکان نمبر ${item.houseNumber} ٹاؤن ${item.town} علاقہ ${item.area} ضلع ${item.zilla}`} <br />
          <b>تاریخ :</b> {formatDate(item.date)}
        </td>
      </tr>
    ));
  };

  return (
    <div className='main-table' style={{ overflowX: 'auto' }}>
      {records.length > 0 && (
        <table className="table table-bordered" style={{ direction: 'rtl', width: '100%', margin: '0 auto', padding: '20px' }}>
          <thead>
            <tr>
              <th>#</th>
              <th>تفصیلات</th>
            </tr>
          </thead>
          <tbody>
            {renderTableRows()}
          </tbody>
        </table>
      )}
      {records.length === 0 && (
        <div className="text-center mt-3">No records found.</div>
      )}
    </div>
  );
};

export default ResponsiveTable;
